const feedConfig = {
    memberFeed: {
        filterLayout: 'FeedFilterNoneLayout',
        listLayout: 'FeedListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
            wr_type : 'post',
            type: 'post',
            wr: 1,
            pa: 0,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getFeed',
    },
    feed: {
        filterLayout: 'FeedFilterDefaultLayout',
        listLayout: 'FeedListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
            wr_type : 'post',
            type: 'post',
            wr: 1,
            pa: 0,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getFeed',
        directUrl: '',
        directType: '',
        keyName: 'wr_id',
        deleteFunc: 'deleteFeed',
        deleteApiParamsSet: {
            wr_type : 'post',
            type: 'post',
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
    },
    detailFeed: {
        getFunc: 'getFeed',
        detailApiParamSet: {
            type: 'post',
            wr_type: 'post',
            wr: 1,
            //       f: 1,
            ha: 1,
            pa: 0,
            cnt: 1,
            it:'Item',
            f: 'File',
        },
        writeFunc: '',
        writeLayouts: ['FeedWriteDefaultLayout'],
        writeApiParamSet: {
        },
        parsingData: {
        },
        keyName: '',
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        deleteFunc: 'deleteFeed',
        deleteApiParamsSet: {
            wr_type : 'post',
            type: 'post',
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
    },
    feedComment: {
        filterLayout: '',
        listLayout: 'FeedCommentListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getFeed',
        listApiParamSet: {
            type: 'post',
            wr_type: 'comment',
            ip : 1,
            wr: 1,
            f: 1,
            it: 1, //아이템
        },
        pageRow: 10,
        paginationType: 'pagination',
        directUrl: '',
        directType: '',
        keyName: '',
    },
    feedReplyComment: {
        filterLayout: '',
        listLayout: 'FeedReplyCommentListLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getFeed',
        listApiParamSet: {
            type: 'post',
            wr_type: 'comment',
            ip : 1,
            wr: 1,
            f: 1,
            it: 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        keyName: '',
    },
}

export default {
    methods: {
        returnFeedConfig(type) {
            return feedConfig[type];
        },
    },
    filterConfig: {
        mbid: { // 작성자 아이디
            type: 'query',
            classname: 'searchInput',
        },
        mbni: { // 작성자 닉네임
            type: 'query',
            classname: 'searchInput',
        },
        id: { // 게시글 번호
            type: 'query',
            classname: 'searchInput',
        },
        ist: { // 등급
            type: 'match',
            classname: 'filterRank',
        },
        se: { // 성별
            type: 'match',
            classname: 'filterSe',
        },
        cr: { // 등록일
            type: 'between',
            classname: 'filterDate'
        },
        tab: {
            type: 'noFilter',
            classname: 'tab',
        },
    }
}
